// Copyright (c) 2022 by Move Closer

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const POINT_LIMIT: number = 5
